// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__q1H5d","navbar__link":"navbar_navbar__link__1vqT9","navbar__li":"navbar_navbar__li__2YCMa","navbar__ul":"navbar_navbar__ul__2iq5S"};